import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { Comentario, Comentarios, User } from '../../app/interfaces';
import { LoginProvider } from '../../providers/login/login';
import { RestApiProvider } from '../../providers/rest-api/rest-api';

/**
 * Generated class for the EditarComentariosDeComentariossComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'editar-comentarios-de-comentarioss',
  templateUrl: 'editar-comentarios-de-comentarioss.html'
})
export class EditarComentariosDeComentariossComponent {

  comentarioPrincipal: Comentarios;
  comentario: Comentarios;
  comentarioTexto: string;
  user: User;

  constructor(public viewCtrl: ViewController,
              public navCtrl: NavController,
              public toastCtrl: ToastController,
              private restApi: RestApiProvider,
              private _loginProvider: LoginProvider,
              public navParams: NavParams)  
  {
    this.comentario = this.navParams.get('comentario');
    if (!this.comentario) {
      return;
    }
    this.comentarioPrincipal = this.navParams.get('comentarioPrincipal');
    if (!this.comentarioPrincipal) {
      return;
    }
  }

  ionViewWillEnter() {
    this._loginProvider.user.subscribe((user: User) => {
      this.user = user;
    });
  }

  postComentarioEditado(comentarioTexto: Comentario) {
    if (!comentarioTexto) {
      return;
    }
    this.restApi.editarComentariodeComentario(comentarioTexto,
      this.comentarioPrincipal, this.user, 
      this.comentario)
      .subscribe((response: any) => { 
          const toast = this.toastCtrl.create({
            message: 'Comentario editado',
            duration: 2000
          });
          toast.present();
    });
    this.cancelar();
  }

  cancelar() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/editar-comentarios-de-comentarioss/editar-comentarios-de-comentarioss.ts